module.exports = __webpack_public_path__ + "static/media/6.aa1e6a78.svg";